import { Controller } from "@hotwired/stimulus"

// Lightweight live-progress poll for the admin Tier A seed card.
// Polls the status JSON every 3s while a run is in flight, patches
// the DOM in place. When the run finishes, forces a full page reload
// so the finished-run summary + "Run Tier A Seed" form slot back in
// without needing custom teardown code.
export default class extends Controller {
  static values = { url: String }
  static targets = ["panel", "current", "processed", "total", "seeded", "failed", "cost", "bar", "fresh", "recentEmpty", "failuresWrap", "failuresList"]

  connect() {
    if (!this.hasPanelTarget) return
    this.poll()
    this.timer = setInterval(() => this.poll(), 3000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  async poll() {
    try {
      const res = await fetch(this.urlValue, { headers: { "Accept": "application/json" } })
      if (!res.ok) return
      const data = await res.json()
      const p = data.progress
      if (!p) return

      if (this.hasCurrentTarget && p.current)      this.currentTarget.textContent = p.current
      if (this.hasProcessedTarget)                 this.processedTarget.textContent = p.processed
      if (this.hasTotalTarget)                     this.totalTarget.textContent = p.total
      if (this.hasSeededTarget)                    this.seededTarget.textContent = p.seeded
      if (this.hasFailedTarget)                    this.failedTarget.textContent = p.failed
      if (this.hasFreshTarget)                     this.freshTarget.textContent = (p.skipped_fresh || 0)
      if (this.hasRecentEmptyTarget)               this.recentEmptyTarget.textContent = (p.skipped_recent_empty || 0)
      if (this.hasCostTarget)                      this.costTarget.textContent = Number(p.est_cost_usd || 0).toFixed(2)
      if (this.hasBarTarget && p.total > 0) {
        this.barTarget.style.width = `${Math.round((p.processed * 100) / p.total)}%`
      }

      // Live failure samples. Show the wrap the moment any failure
      // is captured and rebuild the list from the payload.
      if (this.hasFailuresWrapTarget && this.hasFailuresListTarget) {
        const samples = Array.isArray(p.failure_samples) ? p.failure_samples : []
        if (samples.length > 0) {
          this.failuresWrapTarget.style.display = ""
          this.failuresListTarget.innerHTML = samples.map(s => `
            <li>
              <strong>${this.escape(s.market || "")}</strong>
              <code>${this.escape(s.class || "")}</code>
              <br><small>${this.escape(s.message || "")}</small>
            </li>
          `).join("")
        } else {
          this.failuresWrapTarget.style.display = "none"
        }
      }

      if (p.finished_at) {
        clearInterval(this.timer)
        // Full reload so the finished-state card and the "Run again"
        // form render fresh server-side without more client code.
        setTimeout(() => window.location.reload(), 1500)
      }
    } catch (e) {
      // Transient — poll will retry on next tick.
    }
  }
}
